/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */
import 'core-js';
import 'regenerator-runtime/runtime';

import Vue from 'vue';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */
import '@fortawesome/fontawesome-free/css/all.min.css';
import './plugins/vuex';
import vuetify from './plugins/vuetify';
import './plugins/axios';
import './plugins/fullscreen';
import i18n from './plugins/vue-i18n';
import { router } from './plugins/vue-router';
import './plugins/vue-masonry';
import './plugins/vue-router-back-button';
import './plugins/vue-tooltip';
import './plugins/vue-googlemaps';
import './plugins/spinners';
import './plugins/vue-gtm';
import './plugins/vue-facebook-pixel';
import './plugins/markdown';
import './plugins/floating-vue';
import './directives/intersect';
import './directives/tooltip-improver';
/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 * Stylus is used for this boilerplate.
 *
 * If you don't want to use Stylus, that's fine!
 * Replace the stylus directory with the CSS preprocessor you want.
 * Import the entry point here & install the webpack loader.
 *
 * It's that easy...
 *
 * http://stylus-lang.com/
 */
// import './assets/stylus/app.styl';
/* ============
 * Main App
 * ============
 *
 * Last but not least, we import the main application.
 */
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

store.dispatch('auth/check');

/* eslint-disable no-new */
const vue = new Vue({
  /**
   * Bind the Vue instance to the HTML.
   */
  el: '#app',

  /**
   * The localization plugin.
   */
  i18n,

  /**
   * The router.
   */
  router,

  /**
   * The Vuex store.
   */
  store,

  /**
   * Vuetify library for Material-UI components
   */
  vuetify,

  /**
   * Will render the application.
   *
   * @param {Function} h Will create an element.
   */
  render: h => h(App),
}).$mount('#app');

if (process.env.NODE_ENV !== 'production') {
  window.Vue = vue;
}
